import React, { useContext, useEffect } from 'react';
import theme from '../theme/theme';
import { getAuth } from "firebase/auth";
import { globalStore } from '../state/store';
import { useNavigate } from "react-router-dom";
import { AppBar, Avatar, Box, Button, Grid, IconButton,
  Menu, MenuItem, Toolbar, Tooltip, Typography, useMediaQuery } from '@mui/material';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faSignOutAlt, faCirclePlus, faSignInAlt, faTimes } from '@fortawesome/free-solid-svg-icons';

import cp from '../assets/img/cp.png'
import cp_text from '../assets/img/cp_text.png'

const Header = (props) => {

  const auth = getAuth();

  const headerType = 
    ['Home'].includes(props.page) ? 'home' :
    ['Dashboard', 'Ranking', 'Predict', 'Profile'].includes(props.page) ? 'core' : 'none'

  const settings = [
      { name: 'Profile', icon: faUser, click: e => navigate('/profile') },
      { name: 'Logout', icon: faSignOutAlt, click: e => handleLogout() }
  ]

  //const isLoggedIn = ['core'].includes(headerType);

  const [state, dispatch] = useContext(globalStore);
  const navigate = useNavigate();
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  useEffect(() => {
    return auth.onAuthStateChanged(user => {
      let initObject = {
        //user: null,
        //userBooks: [],
      }

      if (Boolean(user)) { // User is signed in
        initObject.user = { 
          uid: user.uid,
          email: user.email,
          displayName: user.displayName,
          photoURL: user.photoURL,
          creationDate: user.metadata.creationTime,
        }
        /*getUserBooksByUID(user.uid)
        .then((resUbs) => {
          initObject.userBooks = resUbs;
          initUser(initObject) // user is logged in - initialize

        }).catch((err) => console.log("err", err) )*/

      } else { // user is not Logged in - clear initObject
        initUser(initObject)
      }
    });
  }, []);

  function initUser(initObject) {
    //dispatch({ type: "INIT_USER", payload: initObject.user });
    //dispatch({ type: "INIT_USERBOOKS", payload: initObject.userBooks });
  }

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = () => {
    /*initUser({
      user: null,
      userBooks: [],
    })*/
    dispatch({ type: "INIT_USER", payload: null });
    auth.signOut(); // sign out from oauth
    handleCloseUserMenu();
    navigate('/')
  }

  return (
    <AppBar position={isMdUp ? "fixed" : "absolute"} elevation={0}
    sx={{backgroundColor: Boolean(state.user) && 
          state.user.uid === 'hyPRV6TXakMbalAtyb33uDFsOJb2' ? // CP Answer Sheet
            theme.palette.grey[200] :
            //window.scrollY === 0 ?
            //theme.palette.primary.contrastText :
            'rgba(255,255,255,0.7)', 
          backdropFilter: 'blur(10px)', 
          borderBottom: '1px solid' + theme.palette.grey[300]}}>

      <Toolbar disableGutters sx={{ml: 3, mr: 3}}>
        <Box 
        sx={isMdUp ? {mr: 3} : { flexGrow: 1, display: 'flex' }}
        onClick={Boolean(state.user) ? e => navigate('/dashboard') : e => navigate('/home#home')}>
          <Grid container direction="row" alignItems="center" justifyContent={"center"} 
          sx={{marginTop: '5px'}}>
            <Grid item sx={{marginRight: 'auto'}}>
              <img src={cp} alt="cup predictor" width="40"
              style={{margin: '2px 10px 0px 0px', padding: '10px 0px', cursor: 'pointer'}}
              />
            </Grid>
            {isSmUp ?
            <Grid item sx={{ flexGrow: 1, display: { xs: 'none', sm: 'flex' } }}> 
              <img src={cp_text} alt="cup predictor" width="160"
              style={{margin: '0px 3px 4px 0px', padding: '14px 0px', cursor: 'pointer'}}
              />
            </Grid>
            :''}
          </Grid>
        </Box>
        
        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
          {['home'].includes(headerType) ?
          state.menuItems.filter((mi) => !mi.isCore).map((item, i) => (
            <Button
              key={i}
              onClick={Boolean(item.click) ? e => item.click() : e => navigate(item.route)}
              sx={{ //my: 1, //px:2, 
                color: props.page === item.title ? theme.palette.primary.main : theme.palette.grey[700], 
                fontSize: '15px',
                fontWeight: '600',
                padding: '5px 18px 5px 18px',
                margin: '13px 0px 13px 0px',
                display: 'block', 
                '&:hover': { backgroundColor: theme.palette.grey[100] }
              }}
            >
              {item.title}
            </Button>
          ))
          :['core'].includes(headerType) && Boolean(state.user) &&
          Boolean(state.user.displayName) && Boolean(state.user.nickName)
          ?
          state.menuItems.filter((mi) => mi.isCore).map((item, i) => (
            <Button
              key={i}
              onClick={e => navigate(item.route)}
              sx={{ //my: 1, //px:2, 
                color: props.page === item.title ? theme.palette.primary.main : theme.palette.grey[700], 
                fontSize: '16px',
                fontWeight: '500',
                padding: '5px 18px 5px 18px',
                margin: '13px 0px 13px 0px',
                display: 'block', 
                '&:hover': { backgroundColor: theme.palette.grey[100] }
              }}
            >
              <FontAwesomeIcon icon={item.icon} />&nbsp;&nbsp;&nbsp;
              {item.title}
            </Button>
          ))
          :''}
        </Box>

        <Box sx={{ flexGrow: 0 }}>
          {Boolean(state.user) ?
          <>
          <Tooltip title="Open settings" placement="left">
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar alt={state.user.displayName} style={{width: '35px', height: '35px'}}
              src={state.user.photoURL} />
            </IconButton>
          </Tooltip>
          <Menu
            sx={{ mt: '45px' }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            {settings.map((setting, i) => (
              <MenuItem key={i} onClick={setting.click} style={{width: '140px'}}>
                <FontAwesomeIcon icon={setting.icon} 
                style={{color: theme.palette.primary.main, margin: '3px 15px 3px 10px'}} />&nbsp;&nbsp;
                <Typography textAlign="center">{setting.name}</Typography>
              </MenuItem>
            ))}
          </Menu>
          </>
          :['home'].includes(headerType) ?
          <>
          <Button color="secondary" style={{marginRight: '12px', padding: '7px 15px', display: isSmUp ? 'inline-block' : 'none'}}
          onClick={e => navigate('/league/create/0')}>
            Create League
          </Button>
          <Button color="secondary" variant="contained" disableElevation
          onClick={e => navigate('/login')}>
            Sign in&nbsp;&nbsp;<FontAwesomeIcon icon={faSignInAlt} />
          </Button>
          </>
          :
          <Box>

              <IconButton onClick={e => navigate('/home')}>
                <FontAwesomeIcon icon={faTimes} style={{padding: '4px 9px'}} />
              </IconButton>

          </Box>
          }
        </Box>
      </Toolbar>

    </AppBar>
  );
};
export default Header;